<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: '#0E8FB9',
    }"
  >
    <div
      class="page-wrapper"
      :style="{
        backgroundImage: `url(https://assets.rurushishi.com/activies/football/bg.jpg)`,
      }"
    >
      <div class="bg">
        <div class="kv">
          <img
            src="https://assets.rurushishi.com/activies/football/logo_bg1.png"
          />
        </div>
        <div class="podium">
          <div class="second item" v-if="rank_list.length > 1">
            <div class="avatarUrl">
              <template>
                <img class="userImg" :src="rank_list[1].headImg"/>
                <img
                  class="rank"
                  src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank2.png"
                />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="second" class="baseBox">
                <template>
                  <div class="userName">{{ rank_list[1].nickName}}</div>
                  <div class="count">{{ rank_list[1].count }}</div>
                  <div class="tip">澳朵金豆</div>
                </template>
              </div>
            </div>
          </div>
          <div class="first item" v-if="rank_list.length > 0">
            <div class="avatarUrl">
              <template>
                <img class="userImg" :src="rank_list[0].headImg" />
                <img
                  class="rank"
                  src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank1.png"
                />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="first" class="baseBox">
                <template>
                  <div class="userName">{{ rank_list[0].nickName}}</div>
                  <div class="count">{{ rank_list[0].count }}</div>
                  <div class="tip">澳朵金豆</div>
                </template>
              </div>
            </div>
          </div>
          <div class="third item" v-if="rank_list.length > 2">
            <div class="avatarUrl">
              <template>
                <img class="userImg" :src="rank_list[2].headImg" />
                <img
                  class="rank"
                  src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank3.png"
                />
              </template>
            </div>
            <div class="base">
              <div class="noodles"></div>
              <div ref="third" class="baseBox">
                <template>
                  <div class="userName">{{ rank_list[2].nickName}}</div>
                  <div class="count">{{ rank_list[2].count }}</div>
                  <div class="tip">澳朵金豆</div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="model" :style="{ borderColor: '#58A72A' }">
          <div
            class="modelTitle"
            :style="{
              backgroundColor: '#58A72A',
              color: '#fff',
            }"
          >
            · 排行榜 ·
          </div>

          <div class="modelBg">
            <div class="list" >
              <div class="item" v-for="(item, index) in rank_list.slice(3)" :key="index">
                <div class="rank">{{ item.num }}</div>
                <img class="userImg" :src="item.headImg" />
                <div class="userName">{{ item.nickName }}</div>
                <div class="num">{{ item.count }}</div>
                <div class="icon">
                  <span>澳朵金豆</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      rank_list: [],
      team_list: [],
      pageNum: 1,
      pageTeamNum: 1,
      ranking: 0,
      score: 0,
      myTeam: [],
      type: 0,
      loading: false,
      isNoMore: true,
      isTeamNoMore: true,
      rank_item: {},
      myRankNumber: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // upData(type) {
    //   if (type == 0) {
    //     this.totalList();
    //   } else {
    //     this.getAwesomeFriend();
    //   }
    //   this.type = type;
    // },
    // async totalList() {
    //   const data = await this.$httpdf.get(this.apiHost + 'assistance/totalList')
    //   if (data.code == 0) {
    //     this.rank_list = data.data.list
    //     this.myRankNumber = data.data.myRankNumber
    //   }
    // },
    // async getAwesomeFriend() {
    //   const data = await this.$httpdf.get(this.apiHost + 'assistance/getAwesomeFriend')
    //   if (data.code == 0) {
    //     this.rank_list = data.data.list
    //     this.myRankNumber = data.data.myRankNumber
    //   }
    // },
    async totalList() {
      // fc/pointsRanking
      const data = await this.$httpdf.get(this.apiHost + "fc/pointsRanking");
      if (data.code == 0) {
        this.rank_list = data.data;
        console.log( this.rank_list ,'++')
        // this.myRankNumber = data.data.myRankNumber;
      }
    },
  },
  created() {
    this.totalList(); // 获取总排行榜
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 80px;

    .bg {
      position: absolute;
      width: 100%;
      // height: 100vh;
      top: 0;
      // lef: 0;
    //   background-color: rgba(0, 0, 0, 0.5);
    }

    .podium {
      display: flex;
      margin: 30px auto 0;
      justify-content: center;

      .item {
        width: 129px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .avatarUrl {
          position: relative;
          width: 66px;
          height: 66px;
          z-index: 1;

          .userImg {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            border: 2px solid #fff;
            box-sizing: border-box;
          }

          .rank {
            position: absolute;
            top: 42px;
            left: 44px;
            width: 24px;
          }
        }

        .base {
          width: 100%;
          margin-top: -15px;

          .noodles {
            width: 100%;
            border-bottom: 20px solid rgba(255, 255, 255, 0.5);
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
          }

          .baseBox {
            width: 100%;
            height: 100px;
            padding: 0 10px;

            .userName {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              text-align: center;
              color: #ffffff;
              padding-top: 6px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .count {
              font-family: DIN Alternate;
              font-weight: normal;
              font-size: 32px;
              line-height: 24px;
              text-align: center;
              color: #ffffff;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .tip {
              font-size: 10px;
              line-height: 10px;
              text-align: center;
              color: #ffffff;
              margin-top: 6px;
            }
          }
        }
      }

      .second {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }

        .noodles {
          border-right: none !important;
        }
      }

      .third {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }

        .noodles {
          border-left: none !important;
        }
      }
    }

    .kv {
      width: 343px;
      margin: 40px auto 0;
    }

    .model {
      width: 351px;
      margin: 0px auto 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      height: calc(100vh - 284px);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border: 5px solid;
      box-sizing: border-box;
      position: relative;
      top: -1px;

      .modelTitle {
        position: absolute;
        margin-top: -20px;
        font-weight: bold;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        z-index: 1;
        font-size: 20px;
      }

      .modelBg {
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 7px;
        padding: 30px 10px 10px;
        // margin-bottom: 30px;

        .list {
          height: 100%;
          max-height: 610px;
          overflow-y: auto;

          .item {
            width: 100%;
            display: flex;
            height: 54px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);
            padding: 0 10px;
            border-radius: 4px;

            .rank {
              width: 24px;
              height: 24px;
              font-weight: bold;
              font-size: 18px;
              line-height: 24px;
              text-align: center;
              //color: #617086;
              color: #58a72a;
            }

            .userImg {
              width: 32px;
              height: 32px;
              border-radius: 16px;
            }

            .userName {
              flex: 1;
              padding: 0 16px;
              font-weight: normal;
              font-size: 16px;
              line-height: 24px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .num {
              font-weight: bold;
              font-size: 18px;
              line-height: 24px;
              text-align: center;
              color: #262626;
            }

            .icon {
              width: 60px;
              display: flex;
              flex-direction: column;
              align-items: center;
              font-weight: 500;
              //font-size: 9px;
              font-size: 12px;
              line-height: 10px;
              //color: #EF1350;
              margin-left: 10px;

              .iconImg {
                width: 16px;
                height: 16px;
                margin-bottom: 5px;
              }
            }
          }

          .item:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>